import * as React from 'react';
import { createElement } from 'react';
class Input extends React.Component {
    constructor() {
        super(...arguments);
        this.onInputBlur = (e) => {
            const { value } = e.target;
            if (this.props.onBlur) {
                this.props.onBlur(value);
            }
        };
        this.onInputFocus = (e) => {
            const { value } = e.target;
            if (this.props.onFocus) {
                this.props.onFocus(value);
            }
        };
        this.focus = () => {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        };
        this.handleKeyPress = (e) => {
            if (e.key === 'Enter' || e.keyCode === 13) {
                if (this.props.onEnterPress) {
                    this.props.onEnterPress(e);
                }
            }
        };
    }
    render() {
        const { onBlur, onFocus, ...restProps } = this.props;
        return (createElement("input", Object.assign({ ref: el => (this.inputRef = el), onBlur: this.onInputBlur, onFocus: this.onInputFocus, onKeyPress: this.handleKeyPress }, restProps)));
    }
}
export default Input;
